import React from 'react'

type Props = {
  backgroundImage: string
  title: React.ReactNode
  description: React.ReactNode
}

export const DownloadArea: React.FC<Props> = (props) => (
  <>
    <span className="imagelink imagelink--small imagelink--notext grid-gap3-below grid-tablet-gap2-below">
      <div className="imagelink-content">
        <div>
          <div className="imagelink-icon" style={{ backgroundImage: `url('${props.backgroundImage}')` }} />
        </div>
      </div>
    </span>

    <div className="grid-row equalheight-group2 grid-text-center">
      <h2 className="grid-gap1-below" style={{ position: 'relative' }}>
        {props.title}
      </h2>
      <p>{props.description}</p>
    </div>
    <div className="grid-row">
      <div className="grid-span10 grid-shift1 grid-laptop-span12 grid-laptop-shift0">{props.children}</div>
    </div>
  </>
)
